export default __webpack_public_path__ + "static/qRoll-105633e74736dbeb643224ce28757ccb.webp";